/**
 * v2 chat entry point.
 *
 * Registers the Office.js client-tool handlers once, then
 * renders the chat screen. The chat identity (chat id + document id) is owned
 * by the session store and seeded by the host shell, so this component only
 * reads it. Rendering is gated until a chat id exists so the transport never
 * opens against an empty `/chats//...` URL.
 */ import React from "react";
import { ChatScreen } from "./components/ChatScreen";
import { registerOfficeToolHandlers } from "./hooks/clientTools/officeToolHandlers";
import { useChatSessionStore } from "./store/chatSessionStore";
export function ChatV2({ input, setInput }) {
    const chatId = useChatSessionStore((s)=>s.chatId);
    React.useEffect(()=>{
        registerOfficeToolHandlers();
    }, []);
    if (!chatId) return null;
    return /*#__PURE__*/ React.createElement(ChatScreen, {
        key: chatId,
        input: input,
        setInput: setInput
    });
}
